<template>
  <v-container>
    <v-row justify-md="space-between">
      <v-col cols="12" md="auto">
        <v-btn
          @click="openFormDialog"
          class="accent shadow-4 px-8"
          color="success"
          large
          rounded
        >
          Añadir encuesta
        </v-btn>
      </v-col>
    </v-row>

    <!-- show-expand
        single-expand -->
    <br />

    <v-data-table
      :search="search"
      :headers="headers"
      :items="WhatsAppSurveysList"
      item-key="id"
      :loading="isLoading"
      :options.sync="options"
      :server-items-length="totalItems"
      :footer-props="{
        'items-per-page-options': [15, 30, 50, 100],
      }"
    >
      <template v-slot:[`item.whatsapp`]="{ item }">
        <span v-if="item.whatsapp">
          {{ item.whatsapp.name }} - {{ item.whatsapp.number }}
        </span>
      </template>

      <template v-slot:[`item.is_information`]="{ item }">
        <v-chip
          x-small
          label
          :color="item.is_information ? 'primary' : 'blue-grey'"
          outlined
        >
          {{ item.is_information ? "Collect data" : "Normal" }}
        </v-chip>
      </template>

      <template v-slot:[`item.quantity`]="{ item }">
        <span>{{ item.questions.length }}</span>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-chip color="transparent" @click="toggleStatus(item)" small>
          <v-icon left small :color="statusColor(item.status)">
            mdi-radiobox-marked
          </v-icon>
          {{ item.status }}
        </v-chip>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip top color="blue-grey">
          <template v-slot:activator="{ on }">
            <v-hover v-slot:default="{ hover }">
              <v-btn text icon v-on="on" :color="hover ? 'accent' : 'blue-grey'"
                @click.stop="openDetailsDialog(item)">
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </v-hover>
          </template>
          <span>Ver preguntas</span>
        </v-tooltip>

        <v-tooltip top color="blue-grey">
          <template v-slot:activator="{ on }">
            <v-hover v-slot:default="{ hover }">
              <v-btn text icon v-on="on" :color="hover ? 'accent' : 'blue-grey'"
                @click.stop="handleAdd(item)">
                <v-icon>mdi-playlist-plus</v-icon>
              </v-btn>
            </v-hover>
          </template>
          <span>Agregar pregunta</span>
        </v-tooltip>

        <v-tooltip top color="blue-grey">
          <template v-slot:activator="{ on }">
            <v-hover v-slot:default="{ hover }">
              <v-btn text icon v-on="on" :color="hover ? 'accent' : 'blue-grey'"
                @click.stop="handleEdit(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </v-hover>
          </template>
          <span>Editar encuesta</span>
        </v-tooltip>

        <v-tooltip top color="blue-grey">
          <template v-slot:activator="{ on }">
            <v-hover v-slot:default="{ hover }">
              <v-btn text icon v-on="on" :color="hover ? 'error' : 'blue-grey'"
                @click.stop="handleDelete(item.id)">
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </v-hover>
          </template>
          <span>Eliminar encuesta</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <newForm
      v-if="isOpenForm"
      :isActive="isOpenForm"
      :isEditMode="isEditMode"
      :dataToEdit="eventToEdit"
      @close:dialog="closeFormDialog"
    ></newForm>

    <newOptionForm
      v-if="isOpenOptionForm"
      :isActive="isOpenOptionForm"
      :data="optionData"
      @close:dialog="closeOptionFormDialog"
    ></newOptionForm>

    <botDetails
      v-if="isOpenDetails"
      :isActive="isOpenDetails"
      :data="detailsData"
      @close:dialog="closeDetailsDialog"
    ></botDetails>
  </v-container>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import { extractApiError } from "@/utils";
import newForm from "./newForm.vue";
import newOptionForm from "./newFormOptions.vue";
import botDetails from "./showDetails.vue";

export default {
  components: {
    newForm,
    newOptionForm,
    botDetails,
  },

  data: () => ({
    isLoading: false,
    isOpenDetails: false,
    isOpenForm: false,
    isOptionEditMode: false,
    isOpenOptionForm: false,
    isEditMode: false,
    // For pagination
    totalItems: 0,
    options: {
      page: 1,
      itemsPerPage: 15,
    },
    // End for pagination
    WhatsAppSurveysList: [],
    eventToEdit: {},
    optionData: {},
    detailsData: {},
    search: "",
    headers: [
      {
        text: "Título",
        align: "left",
        value: "title",
        class: "primary--text",
        width: "18%",
      },
      {
        text: "WhatsApp",
        align: "left",
        value: "whatsapp",
        class: "primary--text",
        width: "18%",
      },
      {
        text: "Tipo",
        align: "left",
        value: "is_information",
        class: "primary--text",
        width: "10%",
      },
      {
        text: "Estado",
        align: "left",
        value: "status",
        class: "primary--text",
        width: "10%",
      },
      {
        text: "N. Preguntas",
        align: "left",
        value: "quantity",
        class: "primary--text",
        width: "12%",
      },
      {
        text: "Creado",
        align: "left",
        value: "created_at",
        class: "primary--text",
        width: "16%",
      },
      {
        text: "Acciones",
        value: "action",
        class: "primary--text",
        width: "16%",
        align: "left",
        sortable: false,
      },
    ],
  }),

  watch: {
    options: {
      handler() {
        this.getWhatsAppSurveys();
      },
      deep: true,
    },
  },

  mounted() {
    this.getWhatsAppSurveys();
  },

  methods: {
    openFormDialog() {
      this.isOpenForm = true;
    },

    openOptionFormDialog() {
      this.isOpenOptionForm = true;
    },

    openDetailsDialog(item) {
      this.detailsData = item;
      this.isOpenDetails = true;
    },

    handleEdit(item) {
      this.isEditMode = true;
      this.eventToEdit = item;
      this.openFormDialog();
    },

    handleAdd(item) {
      this.isOptionEditMode = true;
      this.optionData = {
        // queue_id: item.closing_queue,
        survey_id: item.id,
      };
      this.openOptionFormDialog();
    },

    async toggleStatus(item) {
      try {
        const { id, ...payload } = item;
        const status = item.status.toLowerCase() === "inactivo" ? "Activo" : "Inactivo";
        await PbxHttpClient.put(`/survey_chats/${id}`, {
          ...payload,
          status,
        });

        this.WhatsAppSurveysList = this.WhatsAppSurveysList.map((el) =>
          el.id === id ? { ...el, status } : el
        );

        this.$snotify.success(`Estado actualizado con éxito.`, "¡Hecho!");
      } catch (err) {
        this.$snotify.error(extractApiError(err, "No se pudo actualizar el estado."), "¡Error!");
      }
    },

    async handleDelete(event) {
      try {
        const confirmRequest = await this.$swalconfirm(
          "Confirmar",
          `¿Está seguro de eliminar esta encuesta? Ésta acción no es reversible.`
        );
        if (confirmRequest.isConfirmed) {
          PbxHttpClient.delete(`/survey_chats/${event}`)
            .then((res) => {
              // El API devuelve el id eliminado en "survey"
              const index = this.WhatsAppSurveysList.findIndex(
                (el) => el.id === res.data.survey
              );
              if (index > -1) {
                this.WhatsAppSurveysList.splice(index, 1);
              }

              this.$snotify.success("Encuesta eliminada", "¡Hecho!");
            })
            .catch((error) => {
              // console.error(error);
              this.$snotify.error(extractApiError(error, "Hubo un error al eliminar."), "Error");
            });
        }
      } catch (error) {
        this.$snotify.error("No se pudo eliminar la encuesta.", "¡Error!");
        // console.error(error);
      }
    },

    closeFormDialog(data = false) {
      if (data && this.isEditMode)
        this.WhatsAppSurveysList = this.WhatsAppSurveysList.map((el) =>
          el.id === data.id ? data : el
        );
      if (data && !this.isEditMode)
        this.WhatsAppSurveysList = [...this.WhatsAppSurveysList, data];
      this.isOpenForm = false;
      this.isEditMode = false;
      this.eventToEdit = {};

      this.getWhatsAppSurveys();
    },

    closeOptionFormDialog(data = false) {
      // if (data && this.isEditMode)
      //   this.WhatsAppSurveysList = this.WhatsAppSurveysList.map((el) =>
      //     el.id === data.id ? data : el
      //   );
      // if (data && !this.isEditMode)
      //   this.WhatsAppSurveysList = [...this.WhatsAppSurveysList, data];

      this.getWhatsAppSurveys();
      this.isOpenOptionForm = false;
      this.optionData = {};
    },

    closeDetailsDialog(data = false) {
      // this.getWhatsAppSurveys();
      this.isOpenDetails = false;
      this.detailsData = {};
    },

    async getWhatsAppSurveys() {
      this.isLoading = true;

      const { page, itemsPerPage } = this.options;

      await PbxHttpClient.get(`/survey_chats`, {
        params: { page, itemPerPage: itemsPerPage },
      })
        .then((res) => {
          this.WhatsAppSurveysList = res.data.data;
          this.totalItems = res.data.total;
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    statusColor(status = "") {
      switch (status.toLowerCase()) {
        case "inactivo":
          return "light-blue";

        default:
          return "success";
      }
    },
  },
};
</script>

<style></style>
